import { FilterConfig } from '../../../common/models/filter.model';
import { FILTER_ITEMS } from './constants-filter-configs';
import { GLOBAL_FILTERS } from './constants';

export const ALIGNMENT_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.surveyQuestionResponse,
  ...GLOBAL_FILTERS,
  FILTER_ITEMS.categoryStatus,
  FILTER_ITEMS.alignmentChange,
  FILTER_ITEMS.previousAlignment,
  FILTER_ITEMS.alignmentScore,
  FILTER_ITEMS.tags,
  FILTER_ITEMS.insightSourceName,
];

export const ALIGNMENT_DETAIL_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.surveyQuestionResponse,
  ...GLOBAL_FILTERS,
  FILTER_ITEMS.categoryStatus,
  FILTER_ITEMS.alignmentChange,
  FILTER_ITEMS.previousAlignment,
  FILTER_ITEMS.alignmentScore,
  FILTER_ITEMS.tags,
  FILTER_ITEMS.insightSourceName,
];

export const ALIGNMENT_SEGMENT_FILTER: FilterConfig[] = [FILTER_ITEMS.total];

export const ALIGNMENT_SUMMARY_SEGMENT_FILTER: FilterConfig[] = [
  ...ALIGNMENT_SEGMENT_FILTER,
  FILTER_ITEMS.previousAlignment,
  FILTER_ITEMS.alignmentScore,
];

export const ALIGNMENT_DETAIL_SEGMENT_FILTER: FilterConfig[] = [
  ...ALIGNMENT_SEGMENT_FILTER,
  FILTER_ITEMS.response,
  FILTER_ITEMS.alignmentScore,
  FILTER_ITEMS.previousAlignment,
];
